import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Report } from "PFApp/booking/types/manage_reports";
import { deleteReport, fetchReport, fetchReports } from "PFCore/services/manage_reports";
import { Collection } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

import { queryKeys } from "./query_keys";

export const useReports = (options?: QueryOptions<Collection<Report[]>>) =>
  useQuery<Collection<Report[]>>(queryKeys.reports, () => fetchReports(), options);

export const useDeleteReports = (reportId: number) => {
  const queryClient = useQueryClient();
  return useMutation((reportId: number) => deleteReport(reportId), {
    mutationKey: queryKeys.deleteReport(reportId),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.templates);
      queryClient.invalidateQueries(queryKeys.reports);
    }
  });
};

export const useReport = (reportId: number, options?: QueryOptions<Report>) =>
  useQuery<Report>(queryKeys.byReportId(reportId), () => fetchReport(reportId), options);
